import axios from 'axios';

export default {
  namespaced: true,
  state: {
    site: null
  },
  getters: {
    site(state) {
      return state.site;
    },
    title(state) {
      return state.site?.title || null;
    },
  },
  mutations: {
    SET_SITE_DATA(state, site) {
      state.site = site;
    }
  },
  actions: {
    async getSiteData({ commit }) {
      let { data } = await axios.get('sites');

      commit('SET_SITE_DATA', data);
    }
  }
};
